export const getToken = state => state.token


// WEBPACK FOOTER //
// ./src/store/getters.js